/* Policy pages (v5 policy). Shopify renders these itself, with no theme template, so this adds what
   the mock has around the text: crumbs above the title, and "On this page" built from the policy's
   headings. The store's policies mark sections with a bold lead-in (<p><strong>Refunds</strong><br>)
   more often than a heading, so both count. The list appears only with three or more entries, and
   each target gets an id. It is a <details>: closed on a phone, so a long list does not push the
   policy a screen down, and open from 900px, where it sits beside the text. Empty paragraphs
   (<p>&nbsp;</p>, used as spacers in the store's policies) are removed; the layout spaces the text.
   The labels come from the script tag (translated in snippets/st-head). */
(() => {
  const script = document.currentScript;
  const run = () => {
    const box = document.querySelector('.shopify-policy__container');
    if (!box || box.dataset.stReady) return;
    box.dataset.stReady = 'true';
    const title = box.querySelector('.shopify-policy__title');
    const body = box.querySelector('.shopify-policy__body');
    const label = (name) => script?.dataset[name] || '';

    if (title) {
      const nav = document.createElement('nav');
      nav.className = 'st-crumbs';
      nav.setAttribute('aria-label', label('crumbs'));
      const home = document.createElement('a');
      home.href = label('homeUrl') || '/';
      home.textContent = label('home');
      const sep = document.createElement('span');
      sep.className = 'st-crumbs__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '/';
      const here = document.createElement('span');
      here.setAttribute('aria-current', 'page');
      here.textContent = title.textContent.trim();
      nav.append(home, sep, here);
      box.insertBefore(nav, title);
    }

    if (!body) return;
    body.querySelectorAll('p').forEach((p) => {
      if (!p.textContent.trim() && !p.querySelector('img, iframe, video')) p.remove();
    });
    // The element before `node`, skipping blank text.
    const prev = (node) => {
      let n = node.previousSibling;
      while (n && n.nodeType === Node.TEXT_NODE && !n.textContent.trim()) n = n.previousSibling;
      return n;
    };
    // A bold lead-in after a blank line inside one long paragraph (<br><br><strong>SECTION 4</strong>):
    // the terms of service mark its 20 sections this way, so they had no contents list (parity review
    // 2026-10-09).
    const afterBlankLine = (el) => {
      const a = prev(el);
      const b = a && prev(a);
      return a?.nodeName === 'BR' && b?.nodeName === 'BR';
    };
    const marks = [...body.querySelectorAll('h2, h3, p strong')].filter((el) => {
      if (el.tagName !== 'STRONG') return true;
      if (el.parentElement?.tagName !== 'P') return false;
      // A bold lead-in only: the paragraph starts with it, or it follows a blank line.
      return !prev(el) || afterBlankLine(el);
    });
    if (marks.length < 3) return;
    const list = document.createElement('ol');
    marks.forEach((el, i) => {
      const target = el.tagName === 'STRONG' && !prev(el) ? el.parentElement : el;
      target.id ||= `policy-${i + 1}`;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${target.id}`;
      a.textContent = el.textContent.replace(/[:\s]+$/, '').trim();
      li.append(a);
      list.append(li);
    });
    const toc = document.createElement('details');
    toc.className = 'st-toc';
    const summary = document.createElement('summary');
    summary.className = 'st-toc__h';
    summary.textContent = label('toc');
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', label('toc'));
    nav.append(list);
    toc.append(summary, nav);
    const wide = window.matchMedia('(min-width: 900px)');
    const sync = () => (toc.open = wide.matches);
    sync();
    wide.addEventListener('change', sync);
    (title || body).after(toc);
    box.classList.add('st-policy--toc');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
